// import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React from "react"

const ScriptFooter = () => <></>

export default ScriptFooter
